const { applyApplicationsModel, applyProspectInquiriesModel, aidApplicationsModel } = require('../model');
const { eedmDestinationModel, applicationTemplateType } = require('./common');
const { isActiveTemplate } = require('../helpers/applicationTemplateHelper');
const requiredAttributesMappings = require('./requiredAttributesMappings');
module.exports = {
    prospect: {
        name: 'apply-prospects',
        maxVersion: '1.0.0',
        supportedVersions: ['1.0.0'],
    },
    inquiry: {
        name: 'apply-prospect-inquiries',
        schema: applyProspectInquiriesModel,
        maxVersion: '1.1.0',
        supportedVersions: ['1.0.0', '1.1.0'],
        erpIdFields: [],
        splitPhoneFields: [{
            numberPath: ['[phones]', 'number'],
            countryCodePath: ['[phones]', 'countryCallingCode']
        }],
        ignoreFields: [
            'pendingUpdates',
            'source',
            'person',
            'personQuery',
        ],
    },
    application: {
        name: 'apply-applications',
        schema: applyApplicationsModel,
        maxVersion: '1.2.0',
        supportedVersions: ['1.0.0', '1.0.1', '1.0.2', '1.2.0'],
        ignoreFields: [
            'submittedOn',
            'withdrawDate',
            'withdrawReason',
            'source',
            'applicationType',
            'templateSourceCode',
            'targetSystemData',
            'transferJobs',
            'fraudStatus',
            'person',
            'personQuery',
            'externalId',
            'submissionConfirmationCode',
            'template',
            'pendingUpdates',
            'erpId',
            'credentialErpId',
            'autoSendToErp',
            'referenceId',
            'pendingStakesUpdate'
        ],
        erpIdFields: [
            ['citizenship', 'visa', 'erpId'],
            ['[secondarySchools]', 'erpId'],
            ['[previousInstitutions]', 'erpId'],
            ['[previousInstitutions]', 'credentialErpId'],
            ['[parentsAndLegalGuardians]', 'erpId']
        ],
        splitPhoneFields: [
            {
                numberPath: ['[phones]', 'number'],
                countryCodePath: ['[phones]', 'countryCallingCode']
            },
            {
                numberPath: ['[emergencyContacts]', 'phoneNumber'],
                countryCodePath: ['[emergencyContacts]', 'countryCallingCode']
            }
        ]
    },
    aid: {
        name: 'aid-applications',
        schema: aidApplicationsModel,
        maxVersion: '1.0.0',
        supportedVersions: ['1.0.0'],
        ignoreFields: [
            'pendingUpdates'
        ],
        // TODO: add ERP ID fields here
        erpIdFields: [],
        splitPhoneFields: [{
            numberPath: ['[phones]', 'number'],
            countryCodePath: ['[phones]', 'countryCallingCode']
        }]
    },
    getSchemaByModelName: function (modelName) {
        switch (modelName) {
            case 'apply-prospects':
                return this.prospect;
            case eedmDestinationModel.applyProspectInquiries:
                return this.inquiry;
            case eedmDestinationModel.applyApplications:
                return this.application;
            case eedmDestinationModel.aidApplications:
                return this.aid;
            default:
                return {};
        }
    },
    getPersonRequiredAttributes: function (templateType) {
        if (templateType && isActiveTemplate(templateType)) {
            return requiredAttributesMappings[templateType];
        } else {
            return requiredAttributesMappings[applicationTemplateType.application]
        }
    }
};
